export default __webpack_public_path__ + "images/e148f1c19253be5aca39686e45d7e3b2-3_web_1919x543.jpg";